<template>
  <v-form ref="form" v-model="validForm">
    <v-row class="px-2" v-if="!participant.rooms || !participant.rooms.selectedRooms || participant.rooms.selectedRooms.length ==0 ">
      <v-col>
        <v-radio-group v-model="hasHotes" :rules="[required]">
          <v-radio :label="$t('hotelsHasHotes')" :value="true"></v-radio>
          <v-radio :label="$t('hotelsNoHotes')" :value="false"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-alert type="warning" v-if="selectionOpen">
      {{ $t('roomDateSelectionConfirm') }}
    </v-alert>
    <v-expansion-panels class="px-1" v-model="expandedHotels" accordion multiple :disabled="!hasHotes">
      <v-expansion-panel v-for="hotel in hotels" :key="hotel.id" :title="$t(hotel.name)" :value="hotel.id">
        <v-expansion-panel-header>
          <v-row>
            <v-col class="title d-flex align-center">
              {{ $t(hotel.name) }}
            </v-col>
            <v-col class="text-subtitle-1 justify-center">
              <!-- 
                <v-rating :value="hotel.stars" color="amber" dense half-increments readonly size="14"></v-rating>
              -->  
              {{ $t("hotelsPriceFrom") }} {{ hotel.minPrice }}
              {{ $t("hotelsPriceTo") }}
              {{ hotel.maxPrice }}
              {{ $t(currency) }}
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-container fluid>
            <v-row>
              <template v-for="room in hotel.rooms" >
                <template v-if="!room.expired || (room.expired && isRoomDatesSelected(room.id))">
                  <v-col cols="12" sm="6" lg="4" v-for="roomPayed in roomPayments(room)" :key="roomPayed.id">
                    <v-card outlined>
                      <v-card-title>{{ room.name }}</v-card-title>
                      <v-card-text>
                        <v-overlay
                          :absolute=true
                          class="align-center justify-center"
                          disabled=true
                          persistent=true
                        >
                          <div>
                            {{ roomPayAccepted(roomPayed.roomReservation.id) ? $t('roomPayed') : $t('roomPayedProcessing')}}
                          </div>
                        </v-overlay>
                        <v-row>
                          <div class="text-subtitle-1">
                          </div>
                        </v-row>
                        <v-row >
                          <v-date-picker readonly :disabled="true" scrollable range full-width color="primary" :value="[roomPayed.roomReservation.startDate,roomPayed.roomReservation.endDate]"
                            :no-title="true"></v-date-picker>
                        </v-row>
                        <v-row >
                          <div class="text-subtitle-1">
                            {{ $t("hotelsRoomTotal") }}
                            {{ roomPayed.roomReservation.nights }}
                            {{ $t("hotelsNights") }}
                            :
                            {{ roomPayed.ammount }}
                            {{ $t(currency) }}
                          </div>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" sm="6" lg="4" :key="room.id">
                    <v-row>
                    <v-card outlined :class="{'selected-item-container' : isRoomDeciding(room.id)&& isRoomDatesSelected(room.id)}">
                      <p class="selected-item-text">{{ $t('roomSelected') }}</p>
                      <v-card-title>{{ $t(room.name) }}</v-card-title>
                      <v-card-text>
                        <v-overlay
                          v-if=" !(isRoomDeciding(room.id)&& isRoomDatesSelected(room.id)) && (room.reserved && room.reserved>=room.total)"
                          :absolute=true
                          class="align-center justify-center"
                          disabled=true
                          persistent=true
                        >
                          <div>
                            {{ $t('roomNoMorePlaces') }}
                          </div>
                        </v-overlay>
                        <v-row>
                          <div class="text-subtitle-1">
                            {{ room.price }}
                            {{ $t(currency) }}/{{ $t("hotelsNight") }} -
                            {{ $t("hotelsValidUntil") }} {{ room.validUntil }}
                          </div>
                        </v-row>
                        <v-row v-if="isRoomDeciding(room.id)">
                          <v-date-picker :disabled="roomDatesSelected[room.id]" scrollable v-model="decidingRooms[decidingRoomIndex(room.id)].dates
                            " :min="startDate" :max="endDate" range full-width color="primary"
                            :no-title="true"></v-date-picker>
                        </v-row>
                        <v-row v-if="isRoomDeciding(room.id)">
                          <div class="text-subtitle-1">
                            {{ $t("hotelsRoomTotal") }}
                            {{ roomSelectedNightsCount(room.id) }}
                            {{ $t("hotelsNights") }}
                            :
                            {{ oneRoomPrice(room.id) }}
                            {{ $t(currency) }}
                          </div>
                        </v-row>
                      </v-card-text>
                      <v-card-actions v-if="!room.expired">
                        <v-btn v-if="!isRoomDeciding(room.id)" color="primary"  @click="selectRoom(room.id)">
                          <span>
                            {{ $t("hotelsSelect") }}
                          </span>
                        </v-btn>
                        <v-btn v-if="isRoomDeciding(room.id)" color="primary"  @click="unselectRoom(room.id)">                        
                          <span v-if="isRoomDeciding(room.id)">
                            {{ $t("hotelsUnselect") }}
                          </span>
                        </v-btn>
                        <v-btn v-if="isRoomDeciding(room.id) && isRoomDatesSelected(room.id)" color="primary" 
                          @click="modifyDates(room.id)" :disabled="!roomSelectedNightsCount(room.id) > 0">
                          <span>
                            {{ $t("hotelsModify") }}
                          </span>
                        </v-btn>
                        <v-btn x-large v-if="isRoomDeciding(room.id) && !isRoomDatesSelected(room.id)" color="primary" 
                          @click="confirmDates(room.id)" :disabled="!roomSelectedNightsCount(room.id) > 0">
                          <span>
                            {{ $t("hotelsConfirm") }}
                          </span>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                    </v-row>
                    <v-row v-if="getRoom(room.id)">
                      <v-col cols="12">
                        <v-checkbox class="px-2" :label="$t('roomSponsored')" v-model="getRoom(room.id).sponsored">
                        </v-checkbox>
                      </v-col>
                      <v-col cols="12" v-if="getRoom(room.id).sponsored">
                        <v-text-field v-bind:label="$t('roomSponsoredBy')" v-model="getRoom(room.id).sponsoredBy"
                          :rules="[required]"></v-text-field>
                      </v-col>
                      <v-col cols="12" v-if="getRoom(room.id).sponsored">
                        <v-text-field v-bind:label="$t('roomSponsoredDetails')" v-model="getRoom(room.id).sponsoredDetails"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </template>
              </template>
            </v-row>
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-row class="px-1 align-center">
      <v-col class="text-align-center">
        <div class="title" v-if="!(selectedRooms.length > 0 && totalRoomPrice == 0)">
          {{ $t("hotelsTotalPrice") }} {{ totalRoomPrice }}
          {{ $t(currency) }}
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>
    
<script>
import { participant } from "@/model/participant";
import moment from "moment";
import Vue from "vue";
import { getRoomPayment,isRoomPayed } from "@/utils/utils.js";
export default {
  emits: ["formValid"],
  props: {
    hotels: {
      type: Array,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    startDate: {
      required: true,
    },
    endDate: {
      required: true,
    },
  },
  data() {
    return {
      expandedHotels: [],
      roomDatesSelected: {},
      decidingRooms: [],
      validForm: false,
      participant,
      hasHotes: undefined,
      isFirstLoad: undefined,
      hiddenRequired : undefined,
    };
  },
  watch: {
    validForm(newVal) {
      this.$emit("formValid", newVal && !this.selectionOpen);
    },
    roomDatesSelected(){
      if(this.selectionOpen){
        this.$emit("formValid", false);
      }else{
        this.validate();
      }
    },
    hasHotes(newVal) {
      if (!newVal) {
        this.participant.rooms.selectedRooms = [];
        this.expandedHotels = [];
        this.roomDatesSelected = {};
      }
    },
  },
  computed: {
    selectionOpen : function() {
      if(!this.roomDatesSelected) {
        return false;
      }
      for (const key in this.roomDatesSelected) {
        if (this.roomDatesSelected[key] === false) {
          return true;
        }
      }
      return false;
    },
    totalRoomPrice: function () {
      var totalPrice = 0;

      this.selectedRooms.forEach((selectedRoom) => {
        totalPrice += this.oneRoomPrice(selectedRoom.roomId);
      });

      return totalPrice;
    },
    selectedRooms: function () {
      return this.participant.rooms.selectedRooms;
    },
    isAnyRoomDatesSelected: function () {
      let isThere = false;
      for (
        let index = 0;
        index < Object.values(this.roomDatesSelected).length;
        index++
      ) {
        if (Object.values(this.roomDatesSelected)[index] == true) {
          isThere = true;
          break;
        }
      }
      return isThere;
    },
    hotelsPanelsIndex: function () {
      let hotelsIdToPanelIndex = {};
      this.hotels.forEach((hotel, index) => {
        hotelsIdToPanelIndex[hotel.id] = index;
      });
      return hotelsIdToPanelIndex;
    },
  },
  methods: {
    notFirstLoad: function () {
      this.isFirstLoad = false;
      this.expandedHotels = [];
      this.getSelectedHotelsIndex().forEach((expPanelIndex) => {
        if (!this.expandedHotels.includes(expPanelIndex)) {
          this.expandedHotels.push(expPanelIndex);
        }
      });
    },
    calculateHiddenRequiered(){
      if(this.selectionOpen){
        this.hiddenRequired = undefined;
      }else{
        this.hiddenRequired = undefined;
      }
    },
    validate: function () {
      this.$refs.form.validate();
    },
    required: function (value) {
      if (value != undefined) {
        return true;
      } else {
        return this.$t("error.required");
      }
    },
    isRoomDeciding: function (roomId) {
      return this.decidingRoomIndex(roomId) > -1;
    },
    getRoom : function (roomId) {
      const decidingIndex = this.decidingRoomIndex(roomId);
      if(decidingIndex>-1){
        return this.decidingRooms[decidingIndex];
      }
    },
    decidingRoomIndex: function (roomId) {
      for (let i = 0; i < this.decidingRooms.length; i++) {
        if (this.decidingRooms[i].roomId === roomId) {
          return i;
        }
      }
      return -1;
    },
    selectedRoomIndex: function (roomId) {
      for (let i = 0; i < this.selectedRooms.length; i++) {
        
        if (this.selectedRooms[i].roomId === roomId && (!this.selectedRooms[i].roomReservationId || !isRoomPayed(this.participant,this.selectedRooms[i].roomReservationId, true))) {
          return i;
        }
      }
      return -1;
    },
    roomPayAccepted : function (roomReservationId){
      return isRoomPayed(this.participant,roomReservationId);
    },
    selectRoom : function(roomId){
      this.decidingRooms.push({
          roomId: roomId,
          dates: [this.startDate, this.endDate],
        });
      Vue.set(this.roomDatesSelected, roomId, false);  
    },
    unselectRoom : function(roomId){
      const decidingIndex = this.decidingRoomIndex(roomId);
      if (decidingIndex > -1) {
        this.decidingRooms.splice(decidingIndex, 1);
      }
      const selectedIndex = this.selectedRoomIndex(roomId);
      if(selectedIndex > -1 ){
        this.selectedRooms.splice(selectedIndex, 1);
      }
      Vue.set(this.roomDatesSelected, roomId, true);
      if(this.selectionOpen){
        this.$emit("formValid", false);
      }else{
        this.$emit("formValid", this.validForm);
      }
    },
    roomSelectedNightsCount: function (roomId) {
      let nights = 0;
      this.hotels.forEach((hotel) => {
        hotel.rooms.forEach((room) => {
          if (room.id === roomId) {
            const selectedIdx = this.decidingRoomIndex(room.id);
            if (selectedIdx != -1) {

              const selectedDates = this.decidingRooms[selectedIdx].dates;

              if (selectedDates) {
                if (selectedDates.length > 0) {
                  const startDate = moment(selectedDates[0], "YYYY-MM-DD");
                  let endDate = startDate;
                  if (selectedDates.length > 1) {
                    endDate = moment(selectedDates[1], "YYYY-MM-DD");
                  }
                  nights = Math.abs(endDate.diff(startDate, "days"));
                }
              }
            }
          }
        });
      });
      return nights;
    },
    roomPayments : function(room) {
      const reserved = this.participant.rooms.selectedRooms.filter(selectedRoom=> selectedRoom.roomId == room.id && selectedRoom.roomReservationId );
      let payedReseved = [];
      reserved.forEach((r)=>{
        const payment = getRoomPayment(this.participant,r.roomReservationId, true);
        if(payment) {
          payedReseved.push(payment);
        }
      })
      return payedReseved;
    },
    oneRoomPrice: function (roomId) {
      let totalPrice = 0;
      this.hotels.forEach((hotel) => {
        hotel.rooms.forEach((room) => {
          if (room.id === roomId) {
            const nights = this.roomSelectedNightsCount(roomId);
            totalPrice += nights * room.price;
          }
        });
      });
      return totalPrice;
    },
    isRoomDatesSelected: function (roomId) {
      return this.roomDatesSelected[roomId] == undefined
        ? false
        : this.roomDatesSelected[roomId];
    },
    modifyDates :function (roomId) {
      Vue.set(this.roomDatesSelected, roomId, false);
      this.roomDatesSelected = {
      ...this.roomDatesSelected
      };
    },
    confirmDates : function (roomId) {
      Vue.set(this.roomDatesSelected, roomId, true);
      const currentDecidingRoom = this.decidingRooms[this.decidingRoomIndex(roomId)];
      console.log("currentDecidingRoom",currentDecidingRoom);
      //validate that start is lower than end 
      const startDate = moment(currentDecidingRoom.dates[0], "YYYY-MM-DD");
      if(currentDecidingRoom.dates[1]) {
        const endDate = moment(currentDecidingRoom.dates[1], "YYYY-MM-DD");
        if(startDate > endDate) {
          const tmp = currentDecidingRoom.dates[0];
          currentDecidingRoom.dates[0] = currentDecidingRoom.dates[1];
          currentDecidingRoom.dates[1] = tmp;
        }
      }
      if (currentDecidingRoom) {
        const selectedIndex = this.selectedRoomIndex(roomId);
        if(selectedIndex > -1 ){
          this.selectedRooms[selectedIndex] = currentDecidingRoom;
        }else{
          this.selectedRooms.push(currentDecidingRoom);
        }
      }
      if(this.selectionOpen){
        this.$emit("formValid", false);
      }else{
        this.$emit("formValid", this.validForm);
      }
      
    },
    datesSelectedPayed: function (roomReservationId) {
      const payment = getRoomPayment(this.participant, roomReservationId, true);
      return payment
    },
    getSelectedHotelsIndex: function () {
      let selectedHotels = [];
      this.hotels.forEach((hotel) => {
        hotel.rooms.forEach((room) => {
          this.selectedRooms.forEach((selectedRoom) => {
            if (selectedRoom.roomId == room.id) {
              selectedHotels.push(this.hotelsPanelsIndex[hotel.id]);
            }
          });
        });
      });
      return selectedHotels;
    },
    initLoggedInUserRooms() {
      this.hasHotes = this.selectedRooms.length > 0;
      this.decidingRooms = [];
      this.selectedRooms.forEach(room=>{
        const payment = getRoomPayment(this.participant,room.roomReservationId, true);
        if(!payment) {
          this.decidingRooms.push(room);
          this.roomDatesSelected[room.roomId] = true;
        }
      })
      Object.assign(this.expandedHotels, this.getSelectedHotelsIndex());
    }
  },
  mounted() {
    this.isFirstLoad = true;
    this.initLoggedInUserRooms();
  },
};
</script>
<style scoped lang="css">
.selected-item-container {
  .text--lighten-2 {
    color : black !important;
  }
}
</style>